import { lazy } from 'react';

import { withSuspense } from '@ratehub/base-ui';


const LazyCCCTray = lazy(
    // the comment is optional, but webpack can make use of it when it parses this file
    () => import(/* webpackChunkName: "CreditCardComparisonTray" */ './CreditCardComparisonTray'),
);

export default withSuspense(LazyCCCTray);
